import { GridColDef } from '@mui/x-data-grid/models/colDef/gridColDef';
import { ICityAliasByProviderItem } from 'types';
import { CITY_ALIASES_BY_PROVIDER_HEADER_TITLES } from 'utils/constants/city-aliases-by-provider';
import { CITY_ALIASES_BY_PROVIDER_FIELDS_NAME } from 'utils/enums';

export interface ICityAliasByProviderRow extends ICityAliasByProviderItem {
	'city.name': string;
	'provider.name': string;
}

export const COLUMNS_CONFIG: GridColDef<ICityAliasByProviderRow>[] = [
	{ field: CITY_ALIASES_BY_PROVIDER_FIELDS_NAME.ID, headerName: CITY_ALIASES_BY_PROVIDER_HEADER_TITLES.ID, sortable: false, flex: 1.2, minWidth: 220 },
	{ field: CITY_ALIASES_BY_PROVIDER_FIELDS_NAME.NAME, headerName: CITY_ALIASES_BY_PROVIDER_HEADER_TITLES.NAME, sortable: true, flex: 1.2 },
	{ field: CITY_ALIASES_BY_PROVIDER_FIELDS_NAME.CITY_NAME, headerName: CITY_ALIASES_BY_PROVIDER_HEADER_TITLES.CITY_NAME, sortable: true, flex: 1 },
	{ field: CITY_ALIASES_BY_PROVIDER_FIELDS_NAME.CITY_ID, headerName: CITY_ALIASES_BY_PROVIDER_HEADER_TITLES.CITY_ID, sortable: false, flex: 0.8 },
	{
		field: CITY_ALIASES_BY_PROVIDER_FIELDS_NAME.PROVIDER_NAME,
		headerName: CITY_ALIASES_BY_PROVIDER_HEADER_TITLES.PROVIDER_NAME,
		sortable: true,
		flex: 1,
	},
	{ field: CITY_ALIASES_BY_PROVIDER_FIELDS_NAME.CREATED_AT, headerName: CITY_ALIASES_BY_PROVIDER_HEADER_TITLES.CREATED_AT, sortable: true, flex: 1 },
	{ field: CITY_ALIASES_BY_PROVIDER_FIELDS_NAME.UPDATED_AT, headerName: CITY_ALIASES_BY_PROVIDER_HEADER_TITLES.UPDATED_AT, sortable: true, flex: 1 },
];
